/* global USATBatchEvents */
$(() => {
  const pluginName = 'usatBatchPlugin';
  const dataKey = `plugin_${pluginName}`;
  const $snackBar = $('[data-js-snack-bar]');
  const USAT_WINDOW_SIZE = { width: 700, height: 500 };
  const PURCHASE_TYPES = {
    member: 'member',
    purchase: 'purchase',
    renew: 'renew',
  };
  const STORED_MEMBER_OPTIONS = {
    select: '', // intentional empty string
    other: 'other',
  };
  const VALIDATION_FAILURE_REASONS = {
    invalidMemberNumber: 'invalid-member-number',
    membershipExpired: 'membership-expired',
    missingLastName: 'missing-last-name',
    missingDob: 'missing-dob',
    usatServerError: 'usat-server-error',
  };
  const state = {
    isValid: null,
    purchaseType: null,
    member: {
      isMembershipExpired: false,
      isValid: null,
      isValidating: null,
      showValidateButton: true,
      memberNumber: null,
      selectedMemberNumber: null,
      selectedMemberNumberIsOther: false,
      validationMessage: null,
    },
    purchase: {
      debounceTimer: null,
      forDateOfBirth: null,
      hasMemberships: false,
      hasWaivers: false,
      isLoading: false,
      isRegistrantDateOfBirthInvalid: false,
      waiversActive: null,
      waiversInactive: null,
    },
    renew: {
      debounceTimer: null,
      isLoading: false,
      isLoggedIn: null,
      isProfileMismatch: false,
      hasProfiles: false,
      hasMemberships: false,
      hasWaivers: false,
      memberNumber: null,
      waiversActive: null,
      waiversInactive: null,
    },
  };
  let settings = {};
  let $pluginContainer = null;
  let plugin = null;
  let $elements;

  /**
   * Render the current state of the plugin
   */
  const renderState = () => {
    const isPurchaseTypeMember = state.purchaseType === PURCHASE_TYPES.member;
    const isPurchaseTypeRenew = state.purchaseType === PURCHASE_TYPES.renew;
    const isPurchaseTypePurchase = state.purchaseType === PURCHASE_TYPES.purchase;

    // selected purchase type
    $elements.usat.formMember.toggleClass('d-none', !isPurchaseTypeMember);
    $elements.usat.formRenew.toggleClass('d-none', !isPurchaseTypeRenew);
    $elements.usat.formPurchase.toggleClass('d-none', !isPurchaseTypePurchase);

    // "member" purchase type elements
    $elements.usat.member.storedMemberNumberSelect
      .prop('required', isPurchaseTypeMember)
      .prop('readonly', state.member.isValidating);
    $elements.usat.member.memberNumberInputContainer
      .prop('disabled', !isPurchaseTypeMember)
      .prop('readonly', state.member.isValidating)
      .toggleClass('d-none', state.member.selectedMemberNumber !== STORED_MEMBER_OPTIONS.other);
    $elements.usat.member.memberNumberInput
      .prop('readonly', state.member.isValidating)
      .prop('required', isPurchaseTypeMember)
      .prop(
        'disabled',
        !isPurchaseTypeMember || !(state.member.memberNumber || state.member.selectedMemberNumberIsOther),
      )
      .val(state.member.memberNumber);
    $elements.usat.member.validateButtonContainer.toggleClass('d-none', false);
    $elements.usat.member.validateButton
      .html(state.member.isValidating ? settings.i18n.usatBatch.validating : settings.i18n.usatBatch.validate)
      .prop('disabled', state.member.isValidating)
      .toggleClass('d-none', !state.member.showValidateButton);
    $elements.usat.member.validateButtonContainer.toggleClass('d-none', !state.member.showValidateButton);
    $pluginContainer
      .toggleClass('has-success', state.member.isValid === true)
      .toggleClass('has-error', state.member.isValid === false);
    $elements.usat.member.feedbackStoredMemberNumber
      .html(!state.member.selectedMemberNumberIsOther && state.member.validationMessage)
      .toggleClass('d-none', state.member.selectedMemberNumberIsOther || !state.member.validationMessage);
    $elements.usat.member.feedbackInputMemberNumber
      .html(state.member.selectedMemberNumberIsOther && state.member.validationMessage)
      .toggleClass('d-none', !state.member.selectedMemberNumberIsOther || !state.member.validationMessage);
    $elements.usat.member.expiredButtonContainer.toggleClass('d-none', !state.member.isMembershipExpired);

    // "renewal" purchase type elements
    const isInvalidProfile = !state.renew.memberNumber || state.renew.isProfileMismatch;
    $elements.usat.renew.loading.toggleClass('d-none', !state.renew.isLoading);
    $elements.usat.renew.logInButtonContainer.toggleClass('d-none', state.renew.isLoggedIn !== false);
    $elements.usat.renew.logOutButtonContainer.toggleClass('d-none', !state.renew.isLoggedIn === true);
    $elements.usat.renew.profilesContainer.toggleClass('d-none', !state.renew.hasProfiles);
    $elements.usat.renew.profile
      .prop('disabled', !isPurchaseTypeRenew)
      .prop('required', isPurchaseTypeRenew);
    $elements.usat.renew.profileMismatch.toggleClass('d-none', !state.renew.isProfileMismatch);
    $elements.usat.renew.membershipsContainer
      .toggleClass('d-none', !state.renew.hasMemberships || isInvalidProfile);
    $elements.usat.renew.memberships
      .prop('disabled', !isPurchaseTypeRenew)
      .prop('required', isPurchaseTypeRenew);
    $elements.usat.renew.waiversContainer
      .toggleClass('d-none', !state.renew.hasWaivers || isInvalidProfile);
    $elements.usat.renew.waivers
      .prop('disabled', !isPurchaseTypeRenew)
      .prop('required', isPurchaseTypeRenew);
    $elements.usat.renew.waiversActive?.toggleClass('d-none', false);
    $elements.usat.renew.waiversActiveInputs?.prop('disabled', !isPurchaseTypeRenew);
    $elements.usat.renew.waiversInactive?.toggleClass('d-none', true);
    $elements.usat.renew.waiversInactiveInputs?.prop('disabled', true);

    // "purchase" purchase type elements
    const isInvalidDateOfBirth = state.purchase.isRegistrantDateOfBirthInvalid;
    $elements.usat.purchase.loading.toggleClass('d-none', !state.purchase.isLoading || isInvalidDateOfBirth);
    $elements.usat.purchase.membershipsContainer
      .toggleClass('d-none', !state.purchase.hasMemberships || isInvalidDateOfBirth);
    $elements.usat.purchase.memberships
      .prop('disabled', !isPurchaseTypePurchase)
      .prop('required', isPurchaseTypePurchase);
    $elements.usat.purchase.waiversContainer
      .toggleClass('d-none', !state.purchase.hasWaivers || isInvalidDateOfBirth);
    $elements.usat.purchase.waivers
      .prop('disabled', !isPurchaseTypePurchase)
      .prop('required', isPurchaseTypePurchase);
    $elements.usat.purchase.waiversActive?.toggleClass('d-none', false);
    $elements.usat.purchase.waiversActiveInputs?.prop('disabled', !isPurchaseTypePurchase);
    $elements.usat.purchase.waiversInactive?.toggleClass('d-none', true);
    $elements.usat.purchase.waiversInactiveInputs?.prop('disabled', true);
    $elements.usat.purchase.invalidDateOfBirth.toggleClass('d-none', !isInvalidDateOfBirth);
  };

  /**
   * Set member validation state to successful
   */
  const memberValidationSuccess = () => {
    state.member.isValidating = false;
    state.member.validationMessage = `${settings.i18n.usatBatch.validated} <span class="fa fa-check"></span>`;
    state.member.isValid = true;
    state.member.isMembershipExpired = false;
    state.member.showValidateButton = false;
  };

  /**
   * Set member validation state to failed
   * @param error
   * @param reason
   */
  const memberValidationFail = (error, reason) => {
    state.member.isValidating = false;
    state.member.validationMessage = error;
    state.member.isValid = false;
    state.member.isMembershipExpired = reason === VALIDATION_FAILURE_REASONS.membershipExpired;
    state.member.showValidateButton = [
      VALIDATION_FAILURE_REASONS.invalidMemberNumber,
      VALIDATION_FAILURE_REASONS.missingDob,
      VALIDATION_FAILURE_REASONS.missingLastName,
      VALIDATION_FAILURE_REASONS.usatServerError,
    ].includes(reason);
    renderState();
  };

  /**
   * Validate member with USAT API
   * @param memberNumber
   * @param lastName
   * @param dateOfBirth
   * @returns {*}
   */
  const validateMember = (memberNumber, lastName, dateOfBirth) => $.ajax({
    url: USATBatchEvents.api.validateMember,
    type: 'POST',
    data: { memberNumber, lastName, dateOfBirth },
  }).done(memberValidationSuccess)
    .fail(({ responseJSON: { message, reason } }) => memberValidationFail(message, reason))
    .always(() => {
      state.member.isValidating = false;
      renderState();
    });

  /**
   * Grabs all the registrant's personal information plus does some formatting to work better with USAT
   * @returns {object}
   */
  const getPersonalInformation = () => ({
    usatMemberNumber: $elements.usat.member.memberNumberInput.val() || 0,
    firstName: settings.personalInformation.plugin
      .getGivenName() ?? settings.registrantPersonalInformation.person.givenName,
    lastName: settings.personalInformation.plugin
      .getFamilyName() ?? settings.registrantPersonalInformation.person.familyName,
    dateOfBirth: settings.personalInformation.plugin
      .getDateOfBirth() ?? settings.registrantPersonalInformation.person.dateOfBirth,
  });

  /**
   * Determine if the selected profile matches the registrant's personal information
   * @returns {boolean}
   */
  const resolveIsProfileMismatch = () => {
    const type = state.purchaseType;
    const selectedProfile = $elements.usat[type]?.profile?.filter(':checked');
    if (!selectedProfile?.length) {
      return false;
    }
    const {
      firstName: profileFirstName,
      lastName: profileLastName,
      dateOfBirth: profileDateOfBirth,
    } = selectedProfile.data(settings.selectors.usat.templates.profile.data);
    const {
      firstName: registrantFirstName,
      lastName: registrantLastName,
      dateOfBirth: registrantDateOfBirth,
    } = getPersonalInformation();

    return registrantFirstName?.toLowerCase() !== profileFirstName?.toLowerCase()
      || registrantLastName?.toLowerCase() !== profileLastName?.toLowerCase()
      || registrantDateOfBirth !== profileDateOfBirth;
  };

  /**
   * Determine if the registrant's date of birth is valid
   * @returns {boolean}
   */
  const resolveIsRegistrantDateOfBirthInvalid = () => {
    const { dateOfBirth: dobString } = getPersonalInformation();
    if (!dobString || !/^\d{4}-\d{2}-\d{2}$/.test(dobString)) return true;

    const dateOfBirth = new Date(dobString);
    return Number.isNaN(dateOfBirth.getTime()) === true
      || dateOfBirth > new Date()
      || dateOfBirth.getFullYear() < 1900;
  };

  /**
   * Resolve which waiver elements are active/inactive
   */
  const resolveWaiverElements = () => {
    const type = $elements.usat.purchaseType.filter(':checked').val() || null;
    if (![PURCHASE_TYPES.purchase, PURCHASE_TYPES.renew].includes(type)) return;

    const selectedMembershipId = $elements.usat[type].membership?.filter(':checked').val() || 'none';
    $elements.usat[type].waiversActive = $elements.usat[type].waiver
      .filter(`[${settings.selectors.usat[type].waiver.slice(1, -1)}="${selectedMembershipId}"]`);
    $elements.usat[type].waiversActiveInputs = $elements.usat[type].waiversActive.find('input');
    $elements.usat[type].waiversInactive = $elements.usat[type].waiver
      .filter(`[${settings.selectors.usat[type].waiver.slice(1, -1)}!="${selectedMembershipId}"]`);
    $elements.usat[type].waiversInactiveInputs = $elements.usat[type].waiversInactive.find('input');
  };

  /**
   * Resolve the current state of the plugin
   */
  const resolveState = () => {
    if (!$elements) return;

    state.purchaseType = $elements.usat.purchaseType.filter(':checked').val() || null;
    resolveWaiverElements();

    // "member" purchase type elements
    state.member.selectedMemberNumber = $elements.usat.member.storedMemberNumberSelect.length
      ? $elements.usat.member.storedMemberNumberSelect.val()
      : STORED_MEMBER_OPTIONS.other;
    state.member.selectedMemberNumberIsOther = state.member.selectedMemberNumber === STORED_MEMBER_OPTIONS.other;
    if (state.member.selectedMemberNumber === STORED_MEMBER_OPTIONS.other) {
      state.member.memberNumber = $elements.usat.member.memberNumberInput.val();
    } else if (state.member.selectedMemberNumber !== STORED_MEMBER_OPTIONS.select) {
      state.member.memberNumber = state.member.selectedMemberNumber;
    } else {
      state.member.memberNumber = '';
    }

    // "renew" purchase type elements
    if (state.renew.isLoggedIn === null) {
      state.renew.isLoggedIn = $elements.usat.renew.logInButtonContainer.hasClass('d-none');
    }
    state.renew.memberNumber = $elements.usat.renew.profile?.filter(':checked').val() || null;
    state.renew.hasProfiles = !!$elements.usat.renew.profiles.children().length;
    state.renew.hasMemberships = state.renew.hasProfiles && !!$elements.usat.renew.memberships.children().length;
    state.renew.hasWaivers = state.renew.hasMemberships && !!$elements.usat.renew.waiversActive?.length;
    state.renew.isProfileMismatch = resolveIsProfileMismatch();

    // "purchase" purchase type elements
    state.purchase.isRegistrantDateOfBirthInvalid = resolveIsRegistrantDateOfBirthInvalid();
    state.purchase.hasMemberships = !!$elements.usat.purchase.memberships.children().length;
    state.purchase.hasWaivers = state.purchase.hasMemberships && !!$elements.usat.purchase.waiversActive?.length;
    if (state.purchase.forDateOfBirth === null && state.purchase.hasMemberships) {
      state.purchase.forDateOfBirth = getPersonalInformation().dateOfBirth || null;
    }

    renderState();
  };

  /**
   * Reset all selections to their defaults
   */
  const resetSelections = () => {
    $elements.usat.member.storedMemberNumberSelect.val('');
    $elements.usat.member.memberNumberInput.val('');
    $elements.usat.renew.profile?.prop('checked', false);
    $elements.usat.purchase.membership?.prop('checked', false);
  };

  /**
   * Reset the member validation state
   */
  const resetValidationState = () => {
    state.member.isValidating = false;
    state.member.validationMessage = null;
    state.member.isValid = null;
    state.member.isMembershipExpired = false;
    state.member.showValidateButton = true;
  };

  /**
   * Respond to changes in the stored member number select field
   */
  const storedMemberNumberSelectChangedAction = () => {
    $elements.usat.member.memberNumberInput.val('');
    resetValidationState();
    resolveState();
  };

  /**
   * Respond to changes in the member number input field
   */
  const memberNumberChangedAction = () => {
    state.member.memberNumber = $elements.usat.member.memberNumberInput.val();
    resetValidationState();
    resolveState();
  };

  /**
   * Validate the member number with USAT
   * @param event
   */
  const memberValidateAction = (event) => {
    event.preventDefault();
    const memberNumber = $elements.usat.member.memberNumberInput.val();
    const registrantInformation = getPersonalInformation();
    plugin.validate(memberNumber, USATBatchEvents.usatEventId, registrantInformation);
  };

  const memberExpiredAction = () => {
    resetValidationState();
    $elements.usat.purchaseType.filter(`[value="${PURCHASE_TYPES.renew}"]`).click();
    if (!state.renew.isLoggedIn) {
      $elements.usat.renew.logInButton.click();
    }
  };

  /**
   * Respond to changes in the selected membership
   */
  const membershipChangedAction = () => {
    resolveState();
  };

  const createMembershipOptionWaiversFromTemplate = (type, membershipOptionId, waiver) => {
    const {
      id,
      title,
      body,
      formats: { html, markdown },
      required,
    } = waiver;
    const idAttr = `usat-waiver-${type}-signatory-${id}`;
    const $template = $elements.usat.templates.waiver.clone()
      .removeAttr(settings.selectors.usat.templates.waiver.waiver.slice(1, -1))
      .attr(settings.selectors.usat[type].waiver.slice(1, -1), membershipOptionId);
    $template.find(settings.selectors.usat.templates.waiver.id)
      .prop('name', `usat-batch[waivers][${id}][id]`)
      .val(id);
    $template.find(settings.selectors.usat.templates.waiver.title).text(title);
    $template.find(settings.selectors.usat.templates.waiver.signatoryLabel).prop('for', idAttr);
    $template.find(settings.selectors.usat.templates.waiver.agree)
      .prop('name', `usat-batch[waivers][${id}][agree]`)
      .prop('required', required);
    $template.find(settings.selectors.usat.templates.waiver.signatoryInput)
      .prop('name', `usat-batch[waivers][${id}][signatory]`)
      .prop('required', required)
      .prop('id', idAttr);
    $template.find(settings.selectors.usat.templates.waiver.body).html(
      html || $('<pre></pre>').text(body || markdown || ''),
    );
    $template.find(settings.selectors.usat.templates.waiver.print)
      .prop('href', `${settings.usat.printWaiverUrl}?membershipId=${membershipOptionId}&waiverId=${id}`);
    $elements.usat[type].waivers.append($template);
  };

  const createMembershipOptionsFromTemplate = (type, membershipOption) => {
    const {
      id,
      name,
      short_description: description,
      price,
      waivers,
    } = membershipOption;
    const idAttr = `usat-${type}-membership-${id}`;
    const $template = $elements.usat.templates.membership.clone()
      .removeClass('d-none')
      .removeAttr(settings.selectors.usat.templates.membership.membership.slice(1, -1));
    $template.find(settings.selectors.usat.templates.membership.input)
      .prop('id', idAttr)
      .prop('disabled', false)
      .prop('required', true)
      .val(id);
    $template.find(settings.selectors.usat.templates.membership.label)
      .prop('for', idAttr)
      .text(`${name}: ${Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price)}`);
    $template.find(settings.selectors.usat.templates.membership.description).text(description);
    $elements.usat[type].memberships.append($template);

    waivers.forEach((waiver) => createMembershipOptionWaiversFromTemplate(type, id, waiver));
  };

  /**
   * Get the membership options from USAT
   */
  const getMembershipOptions = () => {
    const type = state.purchaseType;
    if (type === PURCHASE_TYPES.member) return; // can occur on sub-event change
    const { dateOfBirth } = getPersonalInformation();
    if (
      type === PURCHASE_TYPES.purchase
      && state.purchase.forDateOfBirth === dateOfBirth
      && $elements.usat.purchase.membership.length
    ) return;
    $elements.usat[type].memberships.empty();
    $elements.usat[type].waivers.empty();
    resolveState();
    if (type === PURCHASE_TYPES.renew && state.renew.isProfileMismatch) return;
    if (type === PURCHASE_TYPES.purchase && state.purchase.isRegistrantDateOfBirthInvalid) return;
    state[type].isLoading = true;
    resolveState();

    $.ajax({
      url: settings.usat.getMembershipOptionsUrl,
      data: {
        token: settings.usat.registrationToken,
        purchaseType: type,
        memberNumber: state[type].memberNumber,
        dateOfBirth,
      },
    })
      .done((memberships) => {
        if (
          type === PURCHASE_TYPES.purchase
          && !state.purchase.isRegistrantDateOfBirthInvalid
        ) state.purchase.forDateOfBirth = dateOfBirth;

        memberships.forEach((membership) => createMembershipOptionsFromTemplate(type, membership));
        $elements.usat[type].membership = $elements.usat[type].membershipsContainer
          .find(settings.selectors.usat[type].membership);
        $elements.usat[type].waiver = $elements.usat[type].waiversContainer
          .find(settings.selectors.usat[type].waiver);
      })
      .fail(() => {
        $snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: settings.i18n.usatBatch.membershipsLoadError,
        });
      })
      .always(() => {
        state[type].isLoading = false;
        resolveState();
      });
  };

  /**
   * Debounce calls to getMembershipOptions
   */
  const getMembershipOptionsDebounced = () => {
    const type = state.purchaseType;
    clearTimeout(state[type].debounceTimer);
    state[type].debounceTimer = setTimeout(() => getMembershipOptions(), 100);
  };

  /**
   * Respond selected profile change
   */
  const profileChangedAction = () => {
    getMembershipOptionsDebounced();
  };

  /**
   * Get the user's profiles from USAT
   */
  const getProfiles = () => {
    const type = state.purchaseType;
    $elements.usat[type].profiles.empty();
    $elements.usat[type].memberships.empty();
    $elements.usat[type].waivers.empty();
    state[type].isLoading = true;
    resolveState();

    $.ajax({ url: settings.usat.getProfilesUrl, data: { token: settings.usat.registrationToken } })
      .done((profiles) => {
        profiles.forEach(({
          id,
          full_name: fullName,
          first_name: firstName,
          last_name: lastName,
          date_of_birth: dateOfBirth,
          member_number: memberNumber,
        }) => {
          const $template = $elements.usat.templates.profile.clone()
            .removeAttr(settings.selectors.usat.templates.profile.profile.slice(1, -1))
            .removeClass('d-none');
          const profileId = `usat-${type}-profile-${id}`;
          $template.find(settings.selectors.usat.templates.profile.input)
            .data(settings.selectors.usat.templates.profile.data, { firstName, lastName, dateOfBirth })
            .prop('id', profileId)
            .prop('disabled', false)
            .prop('required', true)
            .val(memberNumber);
          $template.find(settings.selectors.usat.templates.profile.label).prop('for', profileId);
          $template.find(settings.selectors.usat.templates.profile.memberNumber).text(memberNumber);
          $template.find(settings.selectors.usat.templates.profile.name).text(fullName);
          const [year, month, day] = dateOfBirth.split('-');
          $template.find(settings.selectors.usat.templates.profile.dateOfBirth).text(
            new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
              .format(new Date(year, month - 1, day)),
          );
          $template.find(settings.selectors.usat.templates.profile.initial).text(firstName.slice(0, 1));
          $elements.usat[type].profiles.append($template);
        });
        $elements.usat[type].profile = $elements.usat[type].profilesContainer
          .find(settings.selectors.usat[type].profile);
      })
      .fail(() => {
        $snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: settings.i18n.usatBatch.profileLoadError,
        });
      })
      .always(() => {
        state[type].isLoading = false;
        resolveState();
      });
  };

  /**
   * Respond to changes in the selected purchase type
   */
  const purchaseTypeChangedAction = () => {
    resetSelections();
    resetValidationState();
    resolveState();
    if (state.purchaseType === PURCHASE_TYPES.purchase) {
      getMembershipOptionsDebounced();
    }
  };

  /**
   * Log the user out of USAT
   * @param {Event} event
   */
  const logoutAction = (event) => {
    event.preventDefault();
    $elements.usat.renew.profiles.empty();
    $elements.usat.renew.memberships.empty();
    $elements.usat.renew.waivers.empty();
    state.renew.isLoggedIn = null;
    state.renew.isLoading = true;
    resolveState();

    $.ajax({ url: settings.usat.logoutUrl, data: { token: settings.usat.registrationToken } })
      .done(() => {
        state.renew.isLoggedIn = false;
        state.renew.isLoading = false;
      })
      .fail(() => {
        state.renew.isLoggedIn = true;
        $snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: settings.i18n.usatBatch.logoutError,
        });
        getProfiles();
      })
      .always(() => {
        resolveState();
      });
  };

  /**
   * Open the login popup window
   * @param {Event} event
   */
  const loginAction = (event) => {
    event.preventDefault();
    const popupWidth = Math.min(USAT_WINDOW_SIZE.width, window.screen.width);
    const popupHeight = Math.min(USAT_WINDOW_SIZE.height, window.screen.height);
    const left = window.parent.screenX + (window.parent.innerWidth / 2) - (popupWidth / 2);
    const top = window.parent.screenY + (window.parent.innerHeight / 2) - (popupHeight / 2);

    window.open(
      `${settings.usat.loginUrl}?token=${settings.usat.registrationToken}`,
      'usatLoginPopup',
      `width=${popupWidth},height=${popupHeight},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    );
  };

  /**
   * Receive messages from the login popup window
   * @param {Event} event
   */
  const receiveMessage = (event) => {
    const { type, data: { usatLoggedIn } } = event;
    if (event.origin !== window.location.origin || type !== 'message' || usatLoggedIn === undefined) return;

    state.renew.isLoggedIn = usatLoggedIn;
    state.renew.isLoading = false;

    if (!state.renew.isLoggedIn) {
      $snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content: settings.i18n.usatBatch.loginError,
      });
    } else {
      getProfiles();
    }

    resolveState();
  };

  /**
   * Respond to changes in the registrant's personal information
   */
  const registrantChangedAction = () => {
    if (state.purchaseType === PURCHASE_TYPES.purchase) {
      resolveState();
      if (!state.purchase.isRegistrantDateOfBirthInvalid) getMembershipOptionsDebounced();
    }

    if (state.purchaseType === PURCHASE_TYPES.renew) {
      if (!state.renew.hasProfiles) return;
      const isProfileMismatchPrevious = state.renew.isProfileMismatch;
      resetValidationState();
      resolveState();
      if (isProfileMismatchPrevious !== state.renew.isProfileMismatch) {
        profileChangedAction();
      }
    }
  };

  /**
   * Attach listeners to everything and do stuff
   */
  const initialize = () => {
    window.addEventListener('message', receiveMessage, false);

    $pluginContainer
      .on('change', settings.selectors.usat.purchaseType, purchaseTypeChangedAction)
      .on('change', settings.selectors.usat.member.storedMemberNumberSelect, storedMemberNumberSelectChangedAction)
      .on('change blur', settings.selectors.usat.member.memberNumberInput, memberNumberChangedAction)
      .on('click', settings.selectors.usat.member.validateButton, memberValidateAction)
      .on('click', settings.selectors.usat.member.expiredButton, memberExpiredAction)
      .on('click', settings.selectors.usat.renew.logInButton, loginAction)
      .on('click', settings.selectors.usat.renew.logOutButton, logoutAction)
      .on('change', settings.selectors.usat.renew.profile, profileChangedAction)
      .on('change', settings.selectors.usat.renew.membership, membershipChangedAction)
      .on('change', settings.selectors.usat.purchase.membership, membershipChangedAction);
  };

  /**
   * Store lots of jquery objects so we can grab them later without constantly rebuilding them
   */
  const storeElements = () => {
    $elements = {
      usat: {
        formMember: $pluginContainer.find(settings.selectors.usat.formMember),
        formPurchase: $pluginContainer.find(settings.selectors.usat.formPurchase),
        formRenew: $pluginContainer.find(settings.selectors.usat.formRenew),
        purchaseType: $pluginContainer.find(settings.selectors.usat.purchaseType),
        member: {
          expiredButton: $pluginContainer.find(settings.selectors.usat.member.expiredButton),
          expiredButtonContainer: $pluginContainer.find(settings.selectors.usat.member.expiredButtonContainer),
          feedbackInputMemberNumber: $pluginContainer.find(settings.selectors.usat.member.feedbackInputMemberNumber),
          feedbackStoredMemberNumber: $pluginContainer.find(settings.selectors.usat.member.feedbackStoredMemberNumber),
          memberNumberInput: $pluginContainer.find(settings.selectors.usat.member.memberNumberInput),
          memberNumberInputContainer: $pluginContainer.find(settings.selectors.usat.member.memberNumberInputContainer),
          storedMemberNumberSelect: $pluginContainer.find(settings.selectors.usat.member.storedMemberNumberSelect),
          validateButtonContainer: $pluginContainer.find(settings.selectors.usat.member.validateButtonContainer),
          validateButton: $pluginContainer.find(settings.selectors.usat.member.validateButton),
        },
        purchase: {
          invalidDateOfBirth: $pluginContainer.find(settings.selectors.usat.purchase.invalidDateOfBirth),
          loading: $pluginContainer.find(settings.selectors.usat.purchase.loading),
          membership: $pluginContainer.find(settings.selectors.usat.purchase.membership),
          memberships: $pluginContainer.find(settings.selectors.usat.purchase.memberships),
          membershipsContainer: $pluginContainer.find(settings.selectors.usat.purchase.membershipsContainer),
          waiver: $pluginContainer
            .find(`${settings.selectors.usat.purchase.waivers} ${settings.selectors.usat.purchase.waiver}`),
          waivers: $pluginContainer.find(settings.selectors.usat.purchase.waivers),
          waiversActive: null,
          waiversActiveInputs: null,
          waiversInactive: null,
          waiversInactiveInputs: null,
          waiversContainer: $pluginContainer.find(settings.selectors.usat.purchase.waiversContainer),
        },
        renew: {
          loading: $pluginContainer.find(settings.selectors.usat.renew.loading),
          logInButton: $pluginContainer.find(settings.selectors.usat.renew.logInButton),
          logInButtonContainer: $pluginContainer.find(settings.selectors.usat.renew.logInButtonContainer),
          logInModal: $pluginContainer.find(settings.selectors.usat.renew.logInModal),
          logOutButton: $pluginContainer.find(settings.selectors.usat.renew.logOutButton),
          logOutButtonContainer: $pluginContainer.find(settings.selectors.usat.renew.logOutButtonContainer),
          profile: $pluginContainer.find(settings.selectors.usat.renew.profile),
          profiles: $pluginContainer.find(settings.selectors.usat.renew.profiles),
          profileMismatch: $pluginContainer.find(settings.selectors.usat.renew.profileMismatch),
          profilesContainer: $pluginContainer.find(settings.selectors.usat.renew.profilesContainer),
          membership: $pluginContainer.find(settings.selectors.usat.renew.membership),
          memberships: $pluginContainer.find(settings.selectors.usat.renew.memberships),
          membershipsContainer: $pluginContainer.find(settings.selectors.usat.renew.membershipsContainer),
          waiver: $pluginContainer
            .find(`${settings.selectors.usat.renew.waivers} ${settings.selectors.usat.renew.waiver}`),
          waivers: $pluginContainer.find(settings.selectors.usat.renew.waivers),
          waiversActive: null,
          waiversActiveInputs: null,
          waiversInactive: null,
          waiversInactiveInputs: null,
          waiversContainer: $pluginContainer.find(settings.selectors.usat.renew.waiversContainer),
        },
        templates: {
          membership: $pluginContainer.find(settings.selectors.usat.templates.membership.membership),
          profile: $pluginContainer.find(settings.selectors.usat.templates.profile.profile),
          waiver: $pluginContainer.find(settings.selectors.usat.templates.waiver.waiver),
        },
      },
    };

    resolveState();
  };

  /**
   * I'm a plugin!
   * @param element
   * @param options
   * @constructor
   */
  const Plugin = function usatBatchPlugin(element, options) {
    plugin = this;
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      personalInformation: null,
      registrantPersonalInformation: null,
      i18n: {
        usatBatch: {
          validate: null,
          validating: null,
          validated: null,
          invalidMemberNumber: null,
          missingLastName: null,
          missingDob: null,
          loginError: null,
          logoutError: null,
          profileLoadError: null,
          membershipsLoadError: null,
          waiversLoadError: null,
        },
      },
      usat: {
        getMembershipOptionsUrl: null,
        getProfilesUrl: null,
        loginUrl: null,
        logoutUrl: null,
        printWaiverUrl: null,
        registrationToken: null,
      },
      selectors: {
        usat: {
          formMember: '[data-js-usat-form-member]',
          formPurchase: '[data-js-usat-form-purchase]',
          formRenew: '[data-js-usat-form-renew]',
          purchaseType: '[data-js-usat-purchase-type]',
          member: {
            expiredButton: '[data-js-usat-form-member-expired-button]',
            expiredButtonContainer: '[data-js-usat-form-member-expired-button-container]',
            feedbackInputMemberNumber: '[data-js-usat-member-feedback-input-member-number]',
            feedbackStoredMemberNumber: '[data-js-usat-member-feedback-stored-member-number]',
            memberNumberInput: '[data-js-usat-form-member-number]',
            memberNumberInputContainer: '[data-js-usat-form-member-container]',
            storedMemberNumberSelect: '[data-js-registrant-stored-member-number]',
            validateButtonContainer: '[data-js-usat-member-validate-container]',
            validateButton: '[data-js-usat-member-validate-button]',
          },
          purchase: {
            invalidDateOfBirth: '[data-js-usat-form-purchase-invalid-date-of-birth]',
            loading: '[data-js-usat-form-purchase-loading]',
            membership: '[data-js-usat-form-purchase-memberships] [data-js-usat-membership-input]',
            memberships: '[data-js-usat-form-purchase-memberships]',
            membershipsContainer: '[data-js-usat-form-purchase-memberships-container]',
            waiver: '[data-js-usat-form-waiver]',
            waivers: '[data-js-usat-form-purchase-waivers]',
            waiversContainer: '[data-js-usat-form-purchase-waivers-container]',
          },
          renew: {
            loading: '[data-js-usat-form-renew-loading]',
            logInButton: '[data-js-usat-form-renew-log-in-button]',
            logInButtonContainer: '[data-js-usat-form-renew-log-in-button-container]',
            logInModal: '[data-js-usat-form-renew-login-modal]',
            logOutButton: '[data-js-usat-form-renew-log-out-button]',
            logOutButtonContainer: '[data-js-usat-form-renew-log-out-button-container]',
            profile: '[data-js-usat-form-renew-profiles] [data-js-usat-profile-input]',
            profiles: '[data-js-usat-form-renew-profiles]',
            profileMismatch: '[data-js-usat-form-renew-profile-mismatch]',
            profilesContainer: '[data-js-usat-form-renew-profiles-container]',
            membership: '[data-js-usat-form-renew-memberships] [data-js-usat-membership-input]',
            memberships: '[data-js-usat-form-renew-memberships]',
            membershipsContainer: '[data-js-usat-form-renew-memberships-container]',
            waiver: '[data-js-usat-form-waiver]',
            waivers: '[data-js-usat-form-renew-waivers]',
            waiversContainer: '[data-js-usat-form-renew-waivers-container]',
          },
          templates: {
            membership: {
              description: '[data-js-usat-membership-description]',
              input: '[data-js-usat-membership-input]',
              label: '[data-js-usat-membership-label]',
              membership: '[data-js-usat-template-membership]',
            },
            profile: {
              data: 'jsUsatProfile',
              dateOfBirth: '[data-js-usat-profile-date-of-birth]',
              memberNumber: '[data-js-usat-profile-member-number]',
              initial: '[data-js-usat-profile-initial]',
              input: '[data-js-usat-profile-input]',
              label: '[data-js-usat-profile-label]',
              name: '[data-js-usat-profile-name]',
              profile: '[data-js-usat-template-profile]',
            },
            waiver: {
              agree: '[data-js-usat-waiver-agree]',
              body: '[data-js-usat-waiver-body]',
              id: '[data-js-usat-waiver-id]',
              print: '[data-js-usat-waiver-print-link]',
              signatoryInput: '[data-js-usat-waiver-signatory-input]',
              signatoryLabel: '[data-js-usat-waiver-signatory-label]',
              title: '[data-js-usat-waiver-title]',
              waiver: '[data-js-usat-template-waiver]',
            },
          },
        },
      },
    };
    this.methods = {
      registrantChanged: registrantChangedAction,
    };
    settings = $.extend(true, {}, this.settings, options);
    $pluginContainer = element;

    initialize();
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('d-none', !isVisible);
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    if (content) {
      $pluginContainer.html(content);
    }

    storeElements();
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Ask the server if everything looks gucci
   * @param memberNumber
   * @param eventId
   * @param registrantDetails
   */
  Plugin.prototype.validate = (memberNumber, eventId, registrantDetails) => {
    state.member.isValidating = true;
    renderState();
    if (!/^\d+$/.test(memberNumber)) {
      memberValidationFail(settings.i18n.usatBatch.invalidMemberNumber, VALIDATION_FAILURE_REASONS.invalidMemberNumber);
    } else if (!registrantDetails.lastName) {
      memberValidationFail(settings.i18n.usatBatch.missingLastName, VALIDATION_FAILURE_REASONS.missingLastName);
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(registrantDetails.dateOfBirth)) {
      memberValidationFail(settings.i18n.usatBatch.missingDob, VALIDATION_FAILURE_REASONS.missingDob);
    } else {
      validateMember(memberNumber, registrantDetails.lastName, registrantDetails.dateOfBirth);
    }
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   * @param options
   * @returns {usatPlugin|Plugin|*}
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
